// import axios from 'axios';
import http from '@/utils/request';

// 查询流量分析
export const getStackParseCode = (data = {}) => http.post({
  url: '/api/report/stack/parse',
  data,
  server: 'monitor',
  withCredentials: false,
  appendApmPrefix: false,
});
